import { getStore } from "../store/tabStore";
import type TabViewState from "../store/schema/TabViewState";
import { type TabState } from "../store/schema/TabViewState";

export default function getPopoutTabsViewState(): TabViewState[] {
    return getStore().tabs.filter(viewState => viewState.state === 3);
}
